import {
    isInViewport,
    isInViewportArea,
    isInViewportOffset,
    showFromFade,
    throttle,
} from "../../js/Util";

gsap.registerPlugin(ScrollTrigger);

if (App.W.width() >= 1100) {
    // let colAdvantages = $(".advantage-items").children("div").length;
    // let currentHeightAdvantagesList = 100 * (colAdvantages - 1);
    // let advantagesMargin = 61.66 * (colAdvantages - 1);
    // $(".advantage").css("height", currentHeightAdvantagesList + "vh");
    // $(".advantage").css("margin-bottom", advantagesMargin + "px");
    //анимация блока преимуществ - десктоп --- НАЧАЛО
    // gsap.fromTo(
    //     $(".advantage-block__left"),
    //     {
    //         "will-change": "width",
    //         width: "69.608%",
    //     },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top -185%",
    //             toggleClass: "_active",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         // y: 100,
    //         width: "29.085%",
    //         ease: "none",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block__right"),
    //     {
    //         "will-change": "width",
    //         width: "29.085%",
    //     },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top -185%",
    //             toggleClass: "_active",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         // y: 100,
    //         width: "69.608%",
    //         ease: "none",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".case-white-block-wrap"),
    //     {},
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top 0%",
    //             scrub: true,
    //             toggleClass: "_active",
    //             // markers: true,
    //             id: "555-",
    //         },
    //         // y: 350,
    //         // "margin-bottom": "700px",
    //         ease: "none",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".case-white-block-wrap"),
    //     {},
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top -38%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         // y: 350,
    //         height: "320vh",
    //         ease: "none",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block-items:not(.advantage-block-items--hide)"),
    //     { "will-change": "opacity", opacity: 1 },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top 0%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         ease: "none",
    //         opacity: 0,
    //         height: 0,
    //         "z-index": -1,
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block__left .advantage-block-items--hide"),
    //     { "will-change": "opacity", opacity: 0, bottom: "40px" },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top -184%",
    //             end: "top -185%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         ease: "none",
    //         opacity: 1,
    //         bottom: "40px",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block__right .advantage-block-items--hide"),
    //     { "will-change": "opacity", opacity: 0 },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top -184%",
    //             end: "top -185%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         ease: "none",
    //         opacity: 1,
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block__left .advantage-block-img"),
    //     { "will-change": "opacity" },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top -185%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         ease: "none",
    //         margin: 0,
    //         "max-width": "307px",
    //         "padding-bottom": "68.496%",
    //         duration: 3,
    //     }
    // );
    // gsap.fromTo(
    //     $(".advantage-block__right .advantage-block-img"),
    //     { "will-change": "opacity" },
    //     {
    //         scrollTrigger: {
    //             trigger: $(".case-white-block-wrap"),
    //             start: "top 0%",
    //             end: "top -185%",
    //             scrub: true,
    //             // markers: true,
    //         },
    //         ease: "none",
    //         "max-width": "356px",
    //         "margin-bottom": "42px",
    //         "padding-bottom": "37.361%",
    //         transform: "translateX(310px)",
    //         duration: 3,
    //     }
    // );
}
//анимация блока преимуществ - десктоп --- КОНЕЦ

//анимация айтемов преимуществ (наложение) - десктоп --- НАЧАЛО
// ScrollTrigger.matchMedia({
//     "(min-width: 1100px)": () => {
//         var panels = gsap.utils.toArray(".advantage-item");

//         //Для появления следующего слайда, кроме первого
//         panels.forEach((panel, i) => {
//             let position = $(panel).attr("data-position");
//             if (i === 0) {
//                 gsap.fromTo(
//                     $(panel),
//                     {
//                         opacity: 0,
//                         bottom: "-50%",
//                     },
//                     {
//                         opacity: 1,
//                         bottom: "0%",
//                         scrollTrigger: {
//                             trigger: panel,
//                             start: "top 50%",
//                             end: "top -100%",
//                             // markers: true,
//                             scrub: true,

//                             id: "block-" + i,
//                         },
//                     }
//                 );
//             }

//             if (i !== 0) {
//                 gsap.fromTo(
//                     $(panel),
//                     {
//                         // opacity: 0,
//                         // bottom: "-" + m + "%",
//                         bottom: "-100%",
//                     },
//                     {
//                         // opacity: 1,
//                         // bottom: "-" + n + "%",
//                         bottom: "-" + (i - 1) * 10 + "%",
//                         scrollTrigger: {
//                             trigger: panel,
//                             start: `top+=${
//                                 (i + 1) * (panel.offsetHeight - 50)
//                             } bottom`,
//                             end: `bottom+=${
//                                 (i + 1) * (panel.offsetHeight - 50)
//                             } bottom`,
//                             // markers: true,
//                             scrub: true,
//                             id: "block-" + i,
//                         },
//                     }
//                 );
//             }
//         });

//         panels.forEach((panel, i) => {
//             let currentLastPanel = panels.length - 2;
//             console.log("currentLastPanel", currentLastPanel);
//             let position = $(panel).attr("data-position");
//             if (panels[i + 1] && i !== currentLastPanel) {
//                 gsap.fromTo(
//                     $(panel).find("p"),
//                     {
//                         // bottom: "-100%",
//                         opacity: 1,
//                         transform: "translate(0, 0)",
//                     },
//                     {
//                         opacity: 0,
//                         transform: "translate(0, -200px)",
//                         // bottom: position,
//                         scrollTrigger: {
//                             trigger: panels[i + 1],
//                             start: `top+=${
//                                 (i + 1) * (panel.offsetHeight - 50)
//                             } 25%`,
//                             end: `bottom+=${
//                                 (i + 1) * (panel.offsetHeight - 50)
//                             } 50%`,
//                             scrub: true,
//                             id: "block-" + i,
//                         },
//                     }
//                 );
//             }
//         });
//     },
// });
//анимация айтемов преимуществ (наложение) - десктоп --- КОНЕЦ

// анимация блоков преимущств на планшете/мобилке
ScrollTrigger.matchMedia({
    "(max-width: 1099px)": () => {
        var panels = gsap.utils.toArray(".advantage-block>div");
        panels.pop();

        panels.forEach((panel, i) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: panel,
                    start: "top " + ($(".header").innerHeight() + 15),
                    endTrigger: ".advantage-block",
                    end:
                        "bottom " +
                        ($(".header").innerHeight() +
                            $(panel).innerHeight() +
                            15),
                    pin: true,
                },
            });
        });
    },
});

// if (App.W.width() < 1100) {
const $advantageItem = $(".js-advantage-item");

$advantageItem.click(function () {
    const $el = $(this);

    // $el.toggleClass("_active");
    // $advantageItem.find("p").slideUp(200);
    // $el.children("p").slideDown(200);

    if ($el.hasClass("_active")) {
        $advantageItem.removeClass("_active");
        $el.removeClass("_active");
        $advantageItem.find("p").slideUp(200);
    } else {
        $advantageItem.removeClass("_active");
        $el.addClass("_active");
        $el.children("p").slideDown(200);
        setTimeout(() => {
            $(".js-advantage-item:not(._active)").find("p").slideUp(200);
        }, 10);
    }
});
// }

if (App.W.width() >= 1100) {
    $(".advantage-block__left").mouseenter(function () {
        $(".advantage-block__right").removeClass("_active");
        $(".advantage-block__right").removeClass("_animate");
        $(this).addClass("_active");
        $(this).removeClass("_on-hidden");
        // setTimeout(() => {
        $(this).addClass("_animate");
        // }, 700);

        // setTimeout(() => {
        $(".advantage-block__right").addClass("_on-hidden");
        // }, 700);
    });

    $(".advantage-block__right").mouseenter(function () {
        $(".advantage-block__left").removeClass("_active");
        $(".advantage-block__left").removeClass("_animate");
        $(this).addClass("_active");
        $(this).removeClass("_on-hidden");
        // setTimeout(() => {
        $(this).addClass("_animate");
        // }, 700);

        // setTimeout(() => {
        $(".advantage-block__left").addClass("_on-hidden");
        // }, 700);
    });
}

if ($(".fact").length) {
    $(".fact").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
if ($(".connection-item").length) {
    $(".connection-item").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}

let firstAdvantageActive = true;

function scrollCheckFirstAdvantage() {
    if (
        isInViewportOffset(
            document.querySelector(".js-advantage-item:first-child"),
            150
        ) &&
        firstAdvantageActive
    ) {
        document
            .querySelector(".js-advantage-item:first-child")
            .classList.add("_active");
        $(".js-advantage-item:first-child").children("p").slideDown(200);
        firstAdvantageActive = false;
    }
}

if ($(".js-advantage-item").length) {
    App.W.on("scroll", throttle(scrollCheckFirstAdvantage, 100));
}
